import { Optional, Pipe, PipeTransform } from '@angular/core';

import { DateAdapter } from './core';
import { createMissingDateImplError } from './datepicker-errors';

@Pipe({
  name: 'dateTimePart',
  standalone: false,
})
export class DateTimePartPipe<D> implements PipeTransform {
  constructor(@Optional() private _dateAdapter: DateAdapter<D>) {
    if (!this._dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
  }

  public transform(value: D): string {
    const hours = `${this._dateAdapter.getHours(value)}`;
    const minutes = `${this._dateAdapter.getMinutes(value)}`;

    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  }
}
